import React from "react";
import "./PartnersStatsComponent.scss";

export default function PartnersStatsComponent() {
    return (
        <div className="partners-stats">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="partners-stats__title">They trust us</h2>
                        <div className="partners-stats__logo-grid">
                            <div className="partners-stats__logo-item">
                                <img src="/images/at-partner-logo.png" alt="Airport Transfer logo" className="partners-stats__logo-img" />
                            </div>
                            <div className="partners-stats__logo-item">
                                <img src="/images/partners/booking-com-logo.png" alt="Booking.com logo" className="partners-stats__logo-img" />
                            </div>
                            <div className="partners-stats__logo-item">
                                <img src="/images/partners/kiwitaxi-logo.webp" alt="KiwiTaxi logo" className="partners-stats__logo-img" />
                            </div>
                            <div className="partners-stats__logo-item">
                                <img src="/images/partners/logo-tripster-blue.webp" alt="Tripster Group logo" className="partners-stats__logo-img" />
                            </div>
                            <div className="partners-stats__logo-item">
                                <img src="/images/partners/mozio-logo.png" alt="Mozio logo" className="partners-stats__logo-img" />
                            </div>
                            <div className="partners-stats__logo-item">
                                <img src="/images/partners/sk-on-hungary-logo.png" alt="Sk on Hungary logo" className="partners-stats__logo-img" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
